module.exports = __webpack_public_path__ + "static/media/marie-rose.08e2dca2.png";